import React from "react"

import { Link } from "gatsby"

import Presentation from '../../../information/Estimate/OSS_Dev_Flow.pdf';

import envelope from "../../../images/Estimate/Icons/envelope.svg"
import {
  Linkedin,
  Facebook,
  Instagram,
  Twitter,
  Behance,
} from "../../../images/Estimate/Icons"

import "./ThankYouMessage.scss"

export default function ThankYouMessage() {
  return (
    <div className="thankyou-container">
      <div className="thankyou-header-container">
        <img src={envelope} />
        <h1 className="header-message">Message Sent</h1>
      </div>
      <div className="sup-description-container">
        <span className="sup-description-upper">
          Thank you for reaching out.{" "}
        </span>
        <span className="sup-description-lower">
          We can not wait to talk more about your project!
        </span>
      </div>
      <span className="sub-description">
        We will contact you within 24 business hours.
      </span>
      <span className="presentation">
        In the meantime, get to know us better by reading{" "}
        <a
          className="blue-text"
          target="_blank"
          href={Presentation}
        >
          OS-system Company Presentation.
        </a>
      </span>
      <span className="sup-social">Learn more about us.</span>
      <span className="sub-social">
        See the latest updates on our social media channels.
      </span>
      <div className="icon-holder">
        <a href="https://www.linkedin.com/company/3552182">
          <Linkedin />
        </a>
        <a href="https://www.facebook.com/ossystem.ltd/">
          <Facebook />
        </a>
        <a href="https://www.instagram.com/ossystem_company/">
          <Instagram />
        </a>
        <a href="https://twitter.com/ossystem_com">
          <Twitter />
        </a>
        <a href="https://www.behance.net/OSSystem">
          <Behance />
        </a>
      </div>
      <Link className="iot-btn" to="/">
        Go back to homepage
      </Link>
    </div>
  )
}
